import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  IconButton,
  Paper,
  Grid,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
 
} from "@mui/material";
import { SnackbarAlert } from "../../utils/commonImports";

import { Delete as DeleteIcon } from "@mui/icons-material";
import { useClientInfo, axiosInstance } from "../../utils/commonImports";
import MyDatePicker from "../../components/MyDatePicker";

import dayjs from "dayjs";

import { createDocument } from "../../api/numberingApi";
import VoucherPrintPreview from "./VoucherPrintPreview";
import ConfirmDialog from "../../components/ConfirmDialog";


export default function VoucherFormAdd({
  vouchersList = [],
  editData,
  onCancel,
  onSuccess,
}) {
  const { clientId } = useClientInfo();
  const [voucherType, setVoucherType] = useState("Payment");

  const [voucher, setVoucher] = useState({
    client_id: clientId,
    voucher_type: "Payment",
    voucher_date: dayjs().format("YYYY-MM-DD"),
    voucher_number: "",
    narration: "",
    paid_through: "",
    received_from: "",
    contra_debit: "",
    contra_credit: "",
    journal_credit: "",
    journal_debit: "",
    voucher_lines: [{ account_ledger_id: "", amount: 0, remarks: "" }],
  });

  const [ledgerAccounts, setLedgerAccounts] = useState([]);
  const [creditLedgers, setCreditLedgers] = useState([]);
  const [debitLedgers, setDebitLedgers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [pendingInvoices, setPendingInvoices] = useState([]);
  const [invoiceAdjustments, setInvoiceAdjustments] = useState([]);

  const [openPrint, setOpenPrint] = useState(false);
  const [printVoucherId, setPrintVoucherId] = useState(null);
  // Keep a one-time snapshot of adjustments when the list loads
  const [initialAdjustMap, setInitialAdjustMap] = useState({});

  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    title: "",
    message: "",
    onConfirm: null,
  });
  const [isSaved, setIsSaved] = useState(false);

  const [initialPurchaseAdjustMap, setInitialPurchaseAdjustMap] = useState({}); // add this state at top

  // 🧩 Payload builder
  const buildSubmissionPayload = () => {
    // =========================
    // 💸 PAYMENT VOUCHER
    // =========================
    if (voucherType === "Payment") {
      const totalAdjustedAmount =
        (invoiceAdjustments || [])
          .filter((a) => a.adjust_amount > 0)
          .reduce((sum, a) => sum + a.adjust_amount, 0) || 0;

      // The main debit ledger (Paid To) — from the first debit line
      const mainDebitLedgerId =
        voucher.voucher_lines?.[0]?.account_ledger_id || null;

      // The main credit ledger (Paid Through)
      const mainCreditLedgerId = voucher.paid_through || null;

      return {
        ...voucher,

        // ✅ Total amount for DB
        total_amount: Number(totalLinesAmount || 0),

        // ✅ Correct ledger_id for DB (store debit ledger)
        ledger_id: mainDebitLedgerId,

        // Ledger Lines (renamed variable)
        voucher_lines: [
          {
            // Credit Side → Paid Through (Cash/Bank)
            account_ledger_id: mainCreditLedgerId,
            debit_amount: 0,
            credit_amount: totalLinesAmount,
          },
          ...voucher.voucher_lines.map((lineItem) => ({
            account_ledger_id: lineItem.account_ledger_id,
            debit_amount: lineItem.amount,
            credit_amount: 0,
          })),
        ],

        // Purchase Bill Adjustments
        voucher_transactions: (invoiceAdjustments || [])
          .filter((a) => a.adjust_amount > 0)
          .map((a) => ({
            purchase_id: a.purchase_id,
            amount: a.adjust_amount,
            transaction_type: "PAYMENT",
            description: "Purchase Bill Adjustment",
          })),

        total_adjusted_amount: totalAdjustedAmount,
      };
    }

    // =========================
    // 💰 RECEIPT VOUCHER
    // =========================
    // if (voucherType === "Receipt") {
    //   const totalAdjustedAmount =
    //     (invoiceAdjustments || [])
    //       .filter((a) => a.adjust_amount > 0)
    //       .reduce((sum, a) => sum + a.adjust_amount, 0) || 0;

    //   // The main credit ledger (Received From - Customer)
    //   const mainCreditLedgerId = voucher.received_from || null;

    //   // The main debit ledger (Received Through - Cash/Bank)
    //   const mainDebitLedgerId =
    //     voucher.voucher_lines?.[0]?.account_ledger_id || null;

    //   return {
    //     ...voucher,

    //     total_amount: Number(totalLinesAmount || 0),

    //     // ✅ Store credit ledger in main voucher
    //     ledger_id: mainCreditLedgerId,

    //     // ✅ Ledger Lines (only 2 entries: one debit, one credit)
    //     voucher_lines: [
    //       {
    //         account_ledger_id: mainDebitLedgerId, // Cash / Bank
    //         debit_amount: totalLinesAmount,
    //         credit_amount: 0,
    //       },
    //       {
    //         account_ledger_id: mainCreditLedgerId, // Customer
    //         debit_amount: 0,
    //         credit_amount: totalLinesAmount,
    //       },
    //     ],

    //     // ✅ Invoice Adjustments (if any)
    //     voucher_transactions: (invoiceAdjustments || [])
    //       .filter((a) => a.adjust_amount > 0)
    //       .map((a) => ({
    //         invoice_id: a.invoice_id,
    //         amount: a.adjust_amount,
    //         transaction_type: "RECEIPT",
    //         description: "Invoice Adjustment",
    //       })),

    //     total_adjusted_amount: totalAdjustedAmount,
    //   };
    // }

    if (voucherType === "Receipt") {

  const totalAdjustedAmount =
    (invoiceAdjustments || [])
      .filter((a) => a.adjust_amount > 0)
      .reduce((sum, a) => sum + a.adjust_amount, 0) || 0;

  const mainCreditLedgerId =
    voucher.received_from || null;

  const mainDebitLedgerId =
    voucher.voucher_lines?.[0]?.account_ledger_id || null;

  // ✅ Get first adjusted invoice
  const adjustedInvoice =
    (invoiceAdjustments || []).find(
      (a) => Number(a.adjust_amount) > 0
    );

  return {

    ...voucher,

    total_amount: Number(totalLinesAmount || 0),

    ledger_id: mainCreditLedgerId,

    voucher_lines: [

      // Debit Entry
      {
        account_ledger_id: mainDebitLedgerId,
        debit_amount: totalLinesAmount,
        credit_amount: 0,
        invoice_id: adjustedInvoice?.invoice_id || null,
      },

      // Credit Entry
      {
        account_ledger_id: mainCreditLedgerId,
        debit_amount: 0,
        credit_amount: totalLinesAmount,
        invoice_id: adjustedInvoice?.invoice_id || null,
      },

    ],

    voucher_transactions: (invoiceAdjustments || [])
      .filter((a) => a.adjust_amount > 0)
      .map((a) => ({
        invoice_id: a.invoice_id,
        amount: a.adjust_amount,
        transaction_type: "RECEIPT",
        description: "Invoice Adjustment",
      })),

    total_adjusted_amount: totalAdjustedAmount,

  };

}
    // =========================
    // 🧾 DEFAULT (Contra / Journal)
    // =========================
    return {
      ...voucher,
      total_amount: Number(totalLinesAmount || 0),
      ledger_id: null, // optional fallback
    };
  };

  const fetchPendingInvoices = async (
    customerLedgerId,
    existingAdjustments = [],
    voucherTypeParam
  ) => {
    const type = voucherTypeParam || voucher.voucher_type;
    if (!customerLedgerId || type !== "Receipt") return [];

    try {
      console.log("📡 Fetching invoices for ledger:", customerLedgerId);

      const res = await axiosInstance.get("/api/vouchers/receipt/pending", {
        params: { client_id: clientId, ledger_id: customerLedgerId },
      });

      const invoices = res.data || [];
      console.log("🧾 API invoices:", invoices);
      console.log("📘 Existing adjustments:", existingAdjustments);

      // Merge pending + already adjusted invoices
      const merged = invoices.map((inv) => {
        const match = existingAdjustments.find(
          (a) => Number(a.invoice_id) === Number(inv.invoiceid)
        );

        return {
          invoice_id: inv.invoiceid,
          invoice_number: inv.invoice_number,
          invoice_date: inv.invoice_date,
          invoice_amount: inv.invoice_amount,
          balance_amount: inv.balance_amount,
          adjust_amount: match ? Number(match.amount) : 0,
        };
      });

      // Add adjusted invoices not in pending list (e.g. fully paid but linked)
      existingAdjustments.forEach((adj) => {
        if (
          !merged.some((m) => Number(m.invoice_id) === Number(adj.invoice_id))
        ) {
          merged.push({
            invoice_id: adj.invoice_id,
            invoice_number: adj.invoice_number || "",
            invoice_date: adj.invoice_date || "",
            invoice_amount: adj.amount || 0,
            balance_amount: 0,
            adjust_amount: Number(adj.amount) || 0,
          });
        }
      });

      setPendingInvoices(merged);
      setInvoiceAdjustments(merged);

      // one-time snapshot of the original adjust amounts for live-balance math
      const snap = {};
      merged.forEach((r) => {
        snap[r.invoice_id] = Number(r.adjust_amount || 0);
      });
      setInitialAdjustMap(snap);

      console.log("✅ Final merged invoices:", merged);

      return merged;
    } catch (err) {
      console.error("❌ Failed to load invoices:", err);
      return [];
    }
  };

  const fetchPendingPurchases = async (
    vendorLedgerId,
    existingAdjustments = [],
    voucherTypeParam
  ) => {
    const type = voucherTypeParam || voucher.voucher_type;
    if (!vendorLedgerId || type !== "Payment") return [];

    try {
      console.log("📡 Fetching purchases for ledger:", vendorLedgerId);

      // ✅ Fetch all pending purchases from backend
      const res = await axiosInstance.get("/api/vouchers/payment/pending", {
        params: { client_id: clientId, ledger_id: vendorLedgerId },
      });

      const purchases = res.data || [];
      console.log("📦 API purchases:", purchases);
      console.log("📘 Existing adjustments:", existingAdjustments);

      // ✅ Merge pending + already adjusted bills
      const merged = purchases.map((bill) => {
        const match = existingAdjustments.find(
          (a) => Number(a.purchase_id) === Number(bill.purchaseid)
        );

        return {
          purchase_id: bill.purchaseid,
          purchase_number: bill.purchase_number,
          purchase_date: bill.purchase_date,
          purchase_amount: bill.purchase_amount,
          balance_amount: bill.balance_amount,
          adjust_amount: match ? Number(match.amount) : 0,
        };
      });

      // ✅ Add adjusted bills not in pending list (e.g., fully paid but linked)
      existingAdjustments.forEach((adj) => {
        if (
          !merged.some((m) => Number(m.purchase_id) === Number(adj.purchase_id))
        ) {
          merged.push({
            purchase_id: adj.purchase_id,
            purchase_number: adj.purchase_number || "",
            purchase_date: adj.purchase_date || "",
            purchase_amount: adj.amount || 0,
            balance_amount: 0,
            adjust_amount: Number(adj.amount) || 0,
          });
        }
      });

      // ✅ Remove duplicate purchase_ids (just in case)
      const uniqueMerged = Object.values(
        merged.reduce((acc, bill) => {
          acc[Number(bill.purchase_id)] = bill;
          return acc;
        }, {})
      );

      setPendingInvoices(uniqueMerged);
      setInvoiceAdjustments(uniqueMerged);

      // ✅ Snapshot original adjust amounts for live balance updates
      const snap = {};
      uniqueMerged.forEach((r) => {
        snap[r.purchase_id] = Number(r.adjust_amount || 0);
      });
      setInitialPurchaseAdjustMap(snap);

      console.log("✅ Final merged purchases:", uniqueMerged);
      return uniqueMerged;
    } catch (err) {
      console.error("❌ Failed to load purchases:", err);
      return [];
    }
  };

  // ==================== Fetch Credit & Debit Ledgers Based on Voucher Type ====================
  useEffect(() => {
    const fetchLedgers = async () => {
      if (!clientId || !voucher.voucher_type) return;

      console.log(
        "📡 Fetching ledgers for:",
        voucher.voucher_type,
        "Client:",
        clientId
      );

      try {
        const [creditRes, debitRes] = await Promise.all([
          axiosInstance.get("/api/vouchers/ledgers", {
            params: {
              voucher_type: voucher.voucher_type,
              side: "credit",
              client_id: clientId,
            },
          }),
          axiosInstance.get("/api/vouchers/ledgers", {
            params: {
              voucher_type: voucher.voucher_type,
              side: "debit",
              client_id: clientId,
            },
          }),
        ]);

        // ✅ Merge both sets for backward compatibility if needed
        const mergedLedgers = [
          ...(creditRes.data || []),
          ...(debitRes.data || []),
        ];

        setCreditLedgers(creditRes.data || []);
        setDebitLedgers(debitRes.data || []);
        setLedgerAccounts(mergedLedgers);
      } catch (err) {
        console.error(
          "❌ Error fetching ledgers:",
          err.response?.status,
          err.response?.data
        );
        setError("Failed to load ledger accounts.");
      }
    };

    fetchLedgers();
  }, [clientId, voucher.voucher_type]);

  useEffect(() => {
    if (ledgerAccounts.length === 0) return;

    let credits = [];
    let debits = [];

    switch (voucherType) {
      case "Payment":
        credits = ledgerAccounts.filter(
          (l) => [15, 16].includes(l.group_id) // Cash, Bank
        );
        debits = ledgerAccounts.filter(
          (l) => [23, 10, 27, 28].includes(l.group_id) // Creditors, Expenses
        );
        break;

      case "Receipt":
        credits = ledgerAccounts.filter(
          (l) => [20].includes(l.group_id) // Sundry Debtors
        );
        debits = ledgerAccounts.filter(
          (l) => [15, 16, 21].includes(l.group_id) // Cash, Bank, TDS
        );
        break;

      case "Contra":
        credits = ledgerAccounts.filter((l) => [15, 16].includes(l.group_id));
        debits = ledgerAccounts.filter((l) => [15, 16].includes(l.group_id));
        break;

      case "Journal":
        credits = ledgerAccounts;
        debits = ledgerAccounts;
        break;

      default:
        credits = ledgerAccounts;
        debits = ledgerAccounts;
    }

    setCreditLedgers(credits);
    setDebitLedgers(debits);
  }, [ledgerAccounts, voucherType]);

  useEffect(() => {
    const loadVoucher = async () => {
      if (!editData?.id) return;

      try {
        console.log("🟢 Loading voucher details for ID:", editData.id);
        const res = await axiosInstance.get(`/api/vouchers/${editData.id}`);
        const data = res.data;
        console.log("🟢 Voucher API Response:", data);

        const lines = data.voucher_lines || [];

        // 🧾 Split debit/credit
        const debitLines = lines.filter((l) => Number(l.debit_amount) > 0);
        const creditLines = lines.filter((l) => Number(l.credit_amount) > 0);

        // Main ledger detection
        let debitLedger = debitLines?.[0]?.account_ledger_id || "";
        let creditLedger = creditLines?.[0]?.account_ledger_id || "";

        console.log("🧩 [3] Detected Ledgers:", { debitLedger, creditLedger });

        // 🧩 Fallback if credit ledger wasn’t detected properly
        if (!creditLedger && lines.length === 2) {
          creditLedger = lines.find(
            (l) => l.account_ledger_id !== debitLedger
          )?.account_ledger_id;
        }

        // 🧩 Prepare clean debit line array for the UI
        const debitFormatted =
          debitLines.length > 0
            ? debitLines.map((l) => ({
                account_ledger_id: l.account_ledger_id,
                amount: Number(l.debit_amount) || 0,
                remarks: l.remarks || "",
              }))
            : [{ account_ledger_id: "", amount: 0, remarks: "" }];

        // 🧩 Build final voucher object
        const updatedVoucher = {
          ...data,
          voucher_date: dayjs(data.voucher_date).format("YYYY-MM-DD"),
          voucher_lines: debitFormatted,
        };

        switch (data.voucher_type) {
          case "Payment":
            updatedVoucher.paid_through = creditLedger;
            break;
          case "Receipt":
            updatedVoucher.received_from = creditLedger;
            break;
          case "Contra":
            updatedVoucher.contra_credit = creditLedger;
            updatedVoucher.contra_debit = debitLedger;
            break;
          case "Journal":
            updatedVoucher.journal_credit = creditLedger;
            updatedVoucher.journal_debit = debitLedger;
            break;
          default:
            break;
        }

        // ✅ Update state first
        setVoucher(updatedVoucher);
        setVoucherType(data.voucher_type);
        console.log("🧩 [4] VoucherType Set:", data.voucher_type);

        await new Promise((res) => setTimeout(res, 300)); // short delay so state & ledgers load

        // ==============================
        // 🧩 Load Pending Invoices (Receipt)
        // ==============================
        if (data.voucher_type === "Receipt" && creditLedger) {
          console.log("📩 Fetching pending invoices for:", creditLedger);
          const pendingInvoicesRes = await fetchPendingInvoices(
            creditLedger,
            data.voucher_transactions || [],
            data.voucher_type
          );

          // 🧠 Map adjusted invoices (restore number/date if available)
          const adjustedInvoices = (data.voucher_transactions || []).map(
            (t) => {
              const match = (pendingInvoicesRes || []).find(
                (inv) => Number(inv.invoiceid) === Number(t.invoice_id)
              );

              return {
                invoice_id: t.invoice_id,
                invoice_number: match?.invoice_number || "",
                invoice_date: match?.invoice_date || "",
                invoice_amount: match?.invoice_amount
                  ? Number(match.invoice_amount)
                  : Number(t.amount) || 0,
                balance_amount: match?.balance_amount
                  ? Number(match.balance_amount)
                  : 0,
                adjust_amount: Number(t.amount) || 0,
              };
            }
          );

          let mergedInvoices = [
            ...adjustedInvoices,
            ...pendingInvoicesRes.filter(
              (inv) =>
                !adjustedInvoices.some(
                  (a) => Number(a.invoice_id) === Number(inv.invoiceid)
                )
            ),
          ];

          // 🧹 Deduplicate by invoice_id, preferring entry with invoice_number (from pending list)
          mergedInvoices = Object.values(
            mergedInvoices.reduce((acc, item) => {
              const key = item.invoice_id;
              if (!acc[key]) {
                acc[key] = item;
              } else {
                // Prefer the version with an invoice_number
                if (item.invoice_number && !acc[key].invoice_number) {
                  acc[key] = item;
                }
              }
              return acc;
            }, {})
          );

          console.log("✅ Final merged (deduped) invoices:", mergedInvoices);
          setPendingInvoices(mergedInvoices);
          setInvoiceAdjustments(mergedInvoices);
        }

        // ==============================
        // 🧾 Load Pending Purchases (Payment)
        // ==============================
        if (data.voucher_type === "Payment" && debitLedger) {
          console.log("📦 Fetching pending purchases for:", debitLedger);
          const pendingBillsRes = await fetchPendingPurchases(
            debitLedger,
            data.voucher_transactions || [],
            data.voucher_type
          );

          // 🧠 Map adjusted purchase bills (restore number/date if available)
          const adjustedBills = (data.voucher_transactions || []).map((t) => {
            const match = (pendingBillsRes || []).find(
              (b) => Number(b.purchaseid) === Number(t.purchase_id)
            );

            return {
              purchase_id: t.purchase_id,
              purchase_number: match?.purchase_number || "",
              purchase_date: match?.purchase_date || "",
              purchase_amount: match?.purchase_amount
                ? Number(match.purchase_amount)
                : Number(t.amount) || 0,
              balance_amount: match?.balance_amount
                ? Number(match.balance_amount)
                : 0,
              adjust_amount: Number(t.amount) || 0,
            };
          });

          // ✅ Merge adjusted + pending (no duplicates)
          let mergedBills = [
            ...adjustedBills,
            ...pendingBillsRes.filter(
              (p) =>
                !adjustedBills.some(
                  (a) => Number(a.purchase_id) === Number(p.purchaseid)
                )
            ),
          ];

          // 🧹 Deduplicate by purchase_id, preferring entry with purchase_number
          mergedBills = Object.values(
            mergedBills.reduce((acc, item) => {
              const key = item.purchase_id;
              if (!acc[key]) {
                acc[key] = item;
              } else {
                // Prefer the one with proper bill number/date from DB
                if (item.purchase_number && !acc[key].purchase_number) {
                  acc[key] = item;
                }
              }
              return acc;
            }, {})
          );

          console.log("✅ Final merged (deduped) purchase bills:", mergedBills);
          setPendingInvoices(mergedBills);
          setInvoiceAdjustments(mergedBills);
        }
      } catch (err) {
        console.error("❌ Failed to fetch voucher:", err);
      }
    };

    loadVoucher();
  }, [editData]);

  // update field in voucher
  const handleVoucherValue = (key, val) =>
    setVoucher((prev) => ({ ...prev, [key]: val }));

  // handle debit lines
  const handleLineChange = (index, field, value) => {
    const lines = [...voucher.voucher_lines];
    lines[index][field] =
      field === "amount" ? (value === "" ? 0 : parseFloat(value)) : value;
    setVoucher((prev) => ({ ...prev, voucher_lines: lines }));
  };

  const addLine = () =>
    setVoucher((prev) => ({
      ...prev,
      voucher_lines: [
        ...prev.voucher_lines,
        { account_ledger_id: "", amount: 0, remarks: "" },
      ],
    }));

  const removeLine = (index) => {
    const lines = [...voucher.voucher_lines];
    lines.splice(index, 1);
    setVoucher((prev) => ({ ...prev, voucher_lines: lines }));
  };

  const totalLinesAmount = voucher.voucher_lines.reduce(
    (sum, l) => sum + (Number(l.amount) || 0),
    0
  );

  const totalAdjusted = invoiceAdjustments.reduce(
    (sum, a) => sum + (Number(a.adjust_amount) || 0),
    0
  );

  // const validateVoucher = () => {
  //   // 💸 PAYMENT
  //   if (voucherType === "Payment") {
  //     return (
  //       voucher.paid_through &&
  //       voucher.voucher_lines.every((l) => l.account_ledger_id && l.amount > 0)
  //     );
  //   }

  //   // 💰 RECEIPT
  //   if (voucherType === "Receipt") {
  //     const hasValidLines = voucher.voucher_lines.every(
  //       (l) => l.account_ledger_id && l.amount > 0
  //     );

  //     let hasInvoiceAdjustment = false;
  //     if (Array.isArray(invoiceAdjustments)) {
  //       hasInvoiceAdjustment = invoiceAdjustments.some(
  //         (a) => a.adjust_amount > 0
  //       );
  //     }

  //     return voucher.received_from && hasValidLines && hasInvoiceAdjustment;
  //   }
  //   // 🔁 CONTRA / JOURNAL
  //   if (voucherType === "Contra" || voucherType === "Journal") {
  //     const debitValid =
  //       voucher.debit_account_id && Number(voucher.debit_amount) > 0;

  //     const creditValid =
  //       voucher.credit_account_id && Number(voucher.credit_amount) > 0;

  //     return debitValid && creditValid;
  //   }

  //   return false;
  // };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   if (!validateVoucher()) {
  //     setError("Please complete all required fields and amounts.");
  //     return;
  //   }

  //   setLoading(true);
  //   let voucherNumber = voucher.voucher_number;
  //   let savedVoucherId = null;

  //   try {
  //     // 🟢 Generate voucher number only for NEW voucher
  //     if (!editData) {
  //       const typeDisplayMap = {
  //         Payment: "Payment Voucher",
  //         Receipt: "Receipt Voucher",
  //         Contra: "Contra Voucher",
  //         Journal: "Journal Voucher",
  //       };

  //       const createdDoc = await createDocument(
  //         clientId,
  //         voucher.voucher_type,
  //         typeDisplayMap[voucher.voucher_type] || "Voucher Document"
  //       );

  //       if (!createdDoc?.document_number) {
  //         throw new Error("Numbering API failed to return a document number");
  //       }

  //       voucherNumber = createdDoc.document_number;
  //     }

  //     // 🧩 Build payload
  //     const payload = {
  //       ...buildSubmissionPayload(),
  //       voucher_number: voucherNumber,
  //     };

  //     let response;

  //     // 🟢 Save or Update
  //     if (editData) {
  //       response = await axiosInstance.put(
  //         `/api/vouchers/${editData.id}`,
  //         payload
  //       );
  //       savedVoucherId = editData.id;
  //       console.log("🟢 Updated voucher ID:", savedVoucherId);
  //       setIsSaved(true);
  //     } else {
  //       response = await axiosInstance.post("/api/vouchers", payload);
  //       console.log("🟢 API response:", response.data);
  //       savedVoucherId = response.data?.voucher_id || response.data?.id || null;
  //       console.log("🟢 Created voucher ID:", savedVoucherId);
  //     }

  //     // ✅ Ask user whether to print now
  //     const shouldPrint = window.confirm(
  //       "Voucher saved successfully! Do you want to print it now?"
  //     );

  //     if (shouldPrint && savedVoucherId) {
  //       setPrintVoucherId(savedVoucherId);
  //       setOpenPrint(true);
  //     } else {
  //       onSuccess && onSuccess();
  //     }
  //   } catch (err) {
  //     console.error("❌ Save failed:", err);
  //     setError(err.message || "Failed to save voucher.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

const validateVoucher = () => {
  // 💸 PAYMENT
  if (voucherType === "Payment") {
    return (
      voucher.paid_through &&
      Array.isArray(voucher.voucher_lines) &&
      voucher.voucher_lines.length > 0 &&
      voucher.voucher_lines.every(
        (l) =>
          l.account_ledger_id &&
          Number(l.amount) > 0
      )
    );
  }

  // 💰 RECEIPT
  if (voucherType === "Receipt") {
    const hasValidLines =
      Array.isArray(voucher.voucher_lines) &&
      voucher.voucher_lines.length > 0 &&
      voucher.voucher_lines.every(
        (l) =>
          l.account_ledger_id &&
          Number(l.amount) > 0
      );

    // ⭐ Advance Receipt
    // No invoice adjustment is required.
    if (voucher.transaction_type === "Advance") {
      return (
        voucher.received_from &&
        hasValidLines
      );
    }

    // ⭐ Receipt against invoice
    // Invoice adjustment is required.
    let hasInvoiceAdjustment = false;

    if (Array.isArray(invoiceAdjustments)) {
      hasInvoiceAdjustment = invoiceAdjustments.some(
        (a) => Number(a.adjust_amount) > 0
      );
    }

    return (
      voucher.received_from &&
      hasValidLines &&
      hasInvoiceAdjustment
    );
  }

  // 🔁 CONTRA / JOURNAL
  if (voucherType === "Contra" || voucherType === "Journal") {
    const debitValid =
      voucher.debit_account_id &&
      Number(voucher.debit_amount) > 0;

    const creditValid =
      voucher.credit_account_id &&
      Number(voucher.credit_amount) > 0;

    return debitValid && creditValid;
  }

  return false;
};
  
 const handleSubmit = async (e) => {
  e.preventDefault();

  if (!validateVoucher()) {
    setError("Please complete all required fields and amounts.");
    return;
  }

  // 🛑 Prevent multiple saves
  if (isSaved) {
    console.warn("⚠️ Voucher already saved — preventing duplicate entry.");
    return;
  }

  setLoading(true);
  let voucherNumber = voucher.voucher_number;
  let savedVoucherId = null;

  try {
    // 🟢 Generate voucher number only for NEW voucher
    if (!editData) {
      const typeDisplayMap = {
        Payment: "Payment Voucher",
        Receipt: "Receipt Voucher",
        Contra: "Contra Voucher",
        Journal: "Journal Voucher",
      };

      const createdDoc = await createDocument(
        clientId,
        voucher.voucher_type,
        typeDisplayMap[voucher.voucher_type] || "Voucher Document"
      );

      if (!createdDoc?.document_number) {
        throw new Error("Numbering API failed to return a document number");
      }

      voucherNumber = createdDoc.document_number;
    }

    // 🧩 Build payload
    const payload = {
      ...buildSubmissionPayload(),
      voucher_number: voucherNumber,
    };

    let response;

    // 🟢 Save or Update
    if (editData) {
      response = await axiosInstance.put(`/api/vouchers/${editData.id}`, payload);
      savedVoucherId = editData.id;
      console.log("🟢 Updated voucher ID:", savedVoucherId);
    } else {
      response = await axiosInstance.post("/api/vouchers", payload);
      console.log("🟢 API response:", response.data);
      savedVoucherId = response.data?.voucher_id || response.data?.id || null;
      console.log("🟢 Created voucher ID:", savedVoucherId);
    }

    // ✅ Mark as saved (prevents double-click issue)
    setIsSaved(true);

    // ✅ Open confirmation dialog
    setConfirmDialog({
      open: true,
      title: "Voucher Saved",
      message: "Voucher saved successfully! Do you want to print it now?",
      onConfirm: () => {
        // Close dialog first
        setConfirmDialog({ open: false, title: "", message: "", onConfirm: null });

        // Open print preview
        if (savedVoucherId) {
          setPrintVoucherId(savedVoucherId);
          setOpenPrint(true);
        }
      },
    });
  } catch (err) {
    console.error("❌ Save failed:", err);
    setError(err.message || "Failed to save voucher.");
  } finally {
    setLoading(false);
  }
};

  return (
    <Paper elevation={2} sx={{ maxWidth: 1350, mx: "auto", mt: 0, p: 3 }}>
      <Typography variant="h5" fontWeight={600} gutterBottom>
        {editData ? "Edit Voucher" : "Add Voucher"}
      </Typography>

      {error && (
        <Typography color="error" sx={{ mb: 1 }}>
          {error}
        </Typography>
      )}


      <form onSubmit={handleSubmit}>
        {/* LINE 1 - Voucher Type and Transaction Type */}
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth size="small" required sx={{ minWidth: 240 }}>
              <InputLabel>Voucher Type</InputLabel>
              <Select
                value={voucherType}
                label="Voucher Type"
                onChange={(e) => {
                  setVoucherType(e.target.value);
                  setVoucher((v) => ({
                    ...v,
                    voucher_type: e.target.value,
                    voucher_lines: [
                      { account_ledger_id: "", amount: 0, remarks: "" },
                    ],
                    paid_through: "",
                    received_through: "",
                    contra_debit: "",
                    contra_credit: "",
                  }));
                }}
                sx={{ minWidth: 200 }}
              >
                <MenuItem value="Payment">Payment</MenuItem>
                <MenuItem value="Receipt">Receipt</MenuItem>
                <MenuItem value="Journal">Journal</MenuItem>
                <MenuItem value="Contra">Contra</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControl
              fullWidth
              size="small"
              required
              sx={{ minWidth: 220, mb: 2 }}
            >
              <InputLabel>Transaction Type</InputLabel>
              <Select
                value={voucher.transaction_type || ""}
                label="Transaction Type"
                onChange={(e) =>
                  handleVoucherValue("transaction_type", e.target.value)
                }
                sx={{ minWidth: 200 }}
              >
                <MenuItem value="Payment">Payment</MenuItem>
                <MenuItem value="Advance">Advance</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        {/* LINE 2 - Voucher Number and Date */}
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Voucher Number"
              fullWidth
              size="small"
              value={voucher.voucher_number}
              onChange={(e) =>
                handleVoucherValue("voucher_number", e.target.value)
              }
           
              sx={{ minWidth: 240 }}
              InputProps={{ sx: { minWidth: 200 } }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <MyDatePicker
              label="Voucher Date"
              value={voucher.voucher_date}
              onChange={(val) => handleVoucherValue("voucher_date", val)}
              inputStyle={{
                fontSize: 14,
                minHeight: 40,
                height: 40,
                padding: "2px 6px",
              }}
              labelStyle={{
                fontSize: 14,
                lineHeight: 1,
                marginBottom: 0,
                top: -13,
                left: 8,
              }}
              containerStyle={{
                width: 320,
                minHeight: 40,
                height: 40,
                marginBottom: 0,
              }}
            />
          </Grid>
        </Grid>

        {/* LINE 3 and 4 - Credit and Debit sections side by side */}
        <Grid container spacing={2} sx={{ mb: 2 }}>
          {/* Left Column: Credit Side */}
          <Grid item xs={12} sm={6}>
            <Typography fontWeight={600} sx={{ mb: 1 }}>
              {voucher.voucher_type === "Payment"
                ? "Paid Through (Credit Account)"
                : voucher.voucher_type === "Receipt"
                ? "Received From (Credit Account)"
                : voucher.voucher_type === "Contra"
                ? "Credit (Cash/Bank)"
                : "Credit (All Ledger Accounts)"}
            </Typography>

            <Grid container spacing={1} alignItems="center">
              <Grid item xs={12} sm={7}>
                <FormControl fullWidth size="small" variant="outlined">
                  <InputLabel>
                    {voucher.voucher_type === "Payment"
                      ? "Paid Through"
                      : voucher.voucher_type === "Receipt"
                      ? "Received From"
                      : "Credit Account"}
                  </InputLabel>
                  <Select
                    value={
                      voucher.voucher_type === "Payment"
                        ? voucher.paid_through || ""
                        : voucher.voucher_type === "Receipt"
                        ? voucher.received_from || ""
                        : voucher.credit_account || ""
                    }
                    label={
                      voucher.voucher_type === "Payment"
                        ? "Paid Through"
                        : voucher.voucher_type === "Receipt"
                        ? "Received From"
                        : "Credit Account"
                    }
                    onChange={(e) => {
                      const val = e.target.value;

                      if (voucher.voucher_type === "Payment") {
                        handleVoucherValue("paid_through", val);
                      } else if (voucher.voucher_type === "Receipt") {
                        handleVoucherValue("received_from", val);
                        fetchPendingInvoices(val); // 🟢 trigger pending invoices fetch
                      } else {
                        handleVoucherValue("credit_account", val);
                      }
                    }}
                    required
                    sx={{ minWidth: 600 }}
                  >
                    {creditLedgers.map((acc) => (
                      <MenuItem key={acc.id} value={acc.id}>
                        {acc.ledger_name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={4} sx={{ ml: 1 }}>
                <TextField
                  label="Credit Amount"
                  type="number"
                  value={Number(totalLinesAmount || 0).toFixed(2)} // always calculated
                  fullWidth
                  size="small"
                  inputProps={{
                    style: { textAlign: "right" },
                    step: "0.01",
                    readOnly: true, // ✅ fully locked
                  }}
                  sx={{
                    backgroundColor: "#f5f5f5", // subtle grey so user knows it's non-editable
                    borderRadius: "4px",
                  }}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Right Column: Debit Side */}
          <Grid item xs={12} sm={6}>
            <Typography fontWeight={600} sx={{ mb: 1 }}>
              {voucher.voucher_type === "Payment"
                ? "Paid To (Debit Lines)"
                : voucher.voucher_type === "Receipt"
                ? "Received Through (Debit Lines)"
                : voucher.voucher_type === "Contra"
                ? "Debit (Cash/Bank)"
                : "Debit (All Ledger Accounts)"}
            </Typography>

            {voucher.voucher_lines.map((line, idx) => (
              <Grid
                container
                spacing={1}
                alignItems="center"
                key={idx}
                sx={{ mb: 2 }}
              >
                <Grid item xs={12} sm={7}>
                  <FormControl fullWidth size="small" variant="outlined">
                    <InputLabel>
                      {voucher.voucher_type === "Payment"
                        ? "Paid To"
                        : voucher.voucher_type === "Receipt"
                        ? "Received Through"
                        : "Debit Account"}
                    </InputLabel>
                    <Select
                      label={
                        voucher.voucher_type === "Payment"
                          ? "Paid To"
                          : voucher.voucher_type === "Receipt"
                          ? "Received Through"
                          : "Debit Account"
                      }
                      value={line.account_ledger_id}
                      onChange={(e) => {
                        const val = e.target.value;
                        handleLineChange(idx, "account_ledger_id", val);

                        // ✅ Only fetch pending PURCHASE bills when Payment voucher and vendor selected
                        if (voucher.voucher_type === "Payment") {
                          fetchPendingPurchases(val);
                        }
                      }}
                      required
                      sx={{ minWidth: 600 }}
                    >
                      {debitLedgers.map((acc) => (
                        <MenuItem key={acc.id} value={acc.id}>
                          {acc.ledger_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={4} sx={{ ml: 1 }}>
                  <TextField
                    label="Debit Amount"
                    type="number"
                    value={Number(line.amount || 0).toFixed(2)} // ✅ show 2 decimals
                    onChange={(e) =>
                      handleLineChange(
                        idx,
                        "amount",
                        parseFloat(e.target.value) || 0
                      )
                    }
                    fullWidth
                    size="small"
                    inputProps={{ style: { textAlign: "right" }, step: "0.01" }} // ✅ right align + decimal step
                  />
                </Grid>

                {voucher.voucher_type !== "Contra" &&
                  voucher.voucher_type !== "Journal" && (
                    <Grid item xs={12} sm={1}>
                      <IconButton
                        aria-label="delete"
                        onClick={() => removeLine(idx)}
                        size="small"
                        disabled={voucher.voucher_lines.length === 1}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Grid>
                  )}

                {idx === voucher.voucher_lines.length - 1 &&
                  (voucher.voucher_type === "Payment" ||
                    voucher.voucher_type === "Receipt") && (
                    <Grid item xs={12}>
                      <Button
                        variant="outlined"
                        onClick={addLine}
                        fullWidth
                        sx={{ mt: 0.5 }}
                      >
                        + ADD LINE
                      </Button>
                    </Grid>
                  )}
              </Grid>
            ))}
          </Grid>
        </Grid>

        {/* NARRATION */}
        <Box sx={{ mb: 2 }}>
          <Typography fontWeight={600}>Narration</Typography>
          <TextField
            placeholder="Narration"
            fullWidth
            size="small"
            value={voucher.narration}
            onChange={(e) => handleVoucherValue("narration", e.target.value)}
            minRows={2}
            multiline
          />
        </Box>

        {/* BILLS LIST (Placeholder) */}
        {voucher.voucher_type === "Receipt" &&
          voucher.transaction_type === "Payment" &&
          pendingInvoices.length > 0 && (
            <Box
              sx={{
                backgroundColor: "#f9f9fc",
                borderRadius: 1,
                p: 2,
                mb: 2,
                border: "1px solid #ddd",
              }}
            >
              <Typography variant="h6" sx={{ mb: 2 }}>
                Pending Invoices
              </Typography>

              <Table
                sx={{
                  border: "1px solid #ccc",
                  "& th, & td": {
                    border: "1px solid #ddd",
                    padding: "6px 8px",
                    fontSize: "0.85rem",
                  },
                }}
              >
                <TableHead sx={{ backgroundColor: "#f0f0f0" }}>
                  <TableRow>
                    <TableCell align="center">Invoice No</TableCell>
                    <TableCell align="center">Date</TableCell>
                    <TableCell align="right">Invoice Amount</TableCell>
                    <TableCell align="right">Balance</TableCell>
                    <TableCell align="right">Adjust Amount</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {pendingInvoices.map((inv, idx) => (
                    <TableRow key={inv.invoice_id || inv.invoiceid}>
                      <TableCell align="center">
                        {inv.invoice_number?.trim() || "-"}
                      </TableCell>
                      <TableCell align="center">
                        {dayjs(inv.invoice_date).isValid()
                          ? dayjs(inv.invoice_date).format("DD-MMM-YYYY")
                          : "-"}
                      </TableCell>
                      <TableCell align="right">
                        {Number(inv.invoice_amount || 0).toFixed(2)}
                      </TableCell>

                      <TableCell align="right">
                        {(() => {
                          const invoiceAmount = Number(inv.invoice_amount || 0);
                          const dbBalance = Number(inv.balance_amount || 0); // from API
                          const currentAdj = Number(
                            invoiceAdjustments[idx]?.adjust_amount ?? 0
                          );

                          // The amount this voucher originally adjusted for this invoice on load
                          const originalAdj = Number(
                            initialAdjustMap[inv.invoice_id] ?? 0
                          );

                          // Base pending depends on mode:
                          // - New: dbBalance
                          // - Edit: dbBalance + originalAdj (restore balance before this voucher's previous adj)
                          const basePending = editData?.id
                            ? dbBalance + originalAdj
                            : dbBalance;

                          // Live remaining after current typing
                          const liveRemaining = Math.max(
                            0,
                            basePending - currentAdj
                          );

                          return liveRemaining.toFixed(2);
                        })()}
                      </TableCell>

                      <TableCell align="right">
                        <TextField
                          type="number"
                          size="small"
                          inputProps={{
                            min: 0,
                            step: "0.01",
                            style: { textAlign: "right", width: "100px" },
                          }}
                          value={
                            invoiceAdjustments[idx]?.adjust_amount !== undefined
                              ? Number(
                                  invoiceAdjustments[idx].adjust_amount
                                ).toFixed(2)
                              : "0.00"
                          }
                          onFocus={(e) => {
                            setInvoiceAdjustments((prev) => {
                              const updated = [...prev];

                              const current = Number(
                                updated[idx]?.adjust_amount || 0
                              );
                              const receiptTotal = Number(
                                totalLinesAmount || 0
                              );
                              const adjustedExclCurrent =
                                Number(totalAdjusted || 0) - current;
                              const remaining = Math.max(
                                0,
                                receiptTotal - adjustedExclCurrent
                              );

                              const autoAdjust = Math.min(
                                Number(inv.balance_amount || 0),
                                remaining
                              );

                              // ✅ Auto-fill only if current is 0.00
                              if (current === 0 && autoAdjust > 0) {
                                updated[idx].adjust_amount = Number(
                                  autoAdjust.toFixed(2)
                                );
                              }

                              return updated;
                            });

                            // Highlight all digits for instant overwrite
                            e.target.select();
                          }}
                          onChange={(e) => {
                            let val = e.target.value;
                            if (val === "") val = "0";
                            const numVal = parseFloat(val) || 0;

                            const current = Number(
                              invoiceAdjustments[idx]?.adjust_amount || 0
                            );
                            const receiptTotal = Number(totalLinesAmount || 0);
                            const adjustedExclCurrent =
                              Number(totalAdjusted || 0) - current;
                            const remaining = Math.max(
                              0,
                              receiptTotal - adjustedExclCurrent
                            );
                            const maxAllowed = Math.min(
                              Number(inv.balance_amount || 0),
                              remaining
                            );

                            let finalVal = numVal;
                            if (numVal > maxAllowed) finalVal = maxAllowed;
                            if (numVal < 0) finalVal = 0;

                            setInvoiceAdjustments((prev) => {
                              const updated = [...prev];
                              updated[idx].adjust_amount = finalVal;
                              return updated;
                            });
                          }}
                          onBlur={(e) => {
                            // ✅ Format to 2 decimals when leaving field
                            const val = parseFloat(e.target.value) || 0;
                            setInvoiceAdjustments((prev) => {
                              const updated = [...prev];
                              updated[idx].adjust_amount = Number(
                                val.toFixed(2)
                              );
                              return updated;
                            });
                          }}
                          disabled={
                            totalAdjusted >= Number(totalLinesAmount || 0) &&
                            (invoiceAdjustments[idx]?.adjust_amount || 0) === 0
                          }
                        />
                      </TableCell>
                    </TableRow>
                  ))}

                  {/* Totals Row */}
                  <TableRow
                    sx={{ backgroundColor: "#fafafa", fontWeight: 600 }}
                  >
                    <TableCell colSpan={2} align="right">
                      Totals:
                    </TableCell>
                    <TableCell align="right">
                      {Number(
                        pendingInvoices.reduce(
                          (sum, inv) => sum + Number(inv.invoice_amount || 0),
                          0
                        )
                      ).toFixed(2)}
                    </TableCell>
                    <TableCell align="right">
                      {Number(
                        pendingInvoices.reduce(
                          (sum, inv, idx) =>
                            sum +
                            ((Number(inv.balance_amount || 0) || 0) -
                              (Number(
                                invoiceAdjustments[idx]?.adjust_amount || 0
                              ) || 0)),
                          0
                        )
                      ).toFixed(2)}
                    </TableCell>
                    <TableCell align="right">
                      {Number(
                        invoiceAdjustments.reduce(
                          (sum, a) => sum + Number(a.adjust_amount || 0),
                          0
                        )
                      ).toFixed(2)}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          )}

        {/* 🧾 PENDING PURCHASE BILLS (For Payment Voucher) */}
        {voucher.voucher_type === "Payment" &&
          voucher.transaction_type === "Payment" &&
          pendingInvoices.length > 0 && (
            <Box
              sx={{
                backgroundColor: "#f9f9fc",
                borderRadius: 1,
                p: 2,
                mb: 2,
                border: "1px solid #ddd",
              }}
            >
              <Typography variant="h6" sx={{ mb: 2 }}>
                Pending Purchase Bills
              </Typography>

              <Table
                sx={{
                  border: "1px solid #ccc",
                  "& th, & td": {
                    border: "1px solid #ddd",
                    padding: "6px 8px",
                    fontSize: "0.85rem",
                  },
                }}
              >
                <TableHead sx={{ backgroundColor: "#f0f0f0" }}>
                  <TableRow>
                    <TableCell align="center">Bill No</TableCell>
                    <TableCell align="center">Date</TableCell>
                    <TableCell align="right">Bill Amount</TableCell>
                    <TableCell align="right">Balance</TableCell>
                    <TableCell align="right">Adjust Amount</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {pendingInvoices.map((bill, idx) => (
                    <TableRow key={bill.purchase_id || bill.purchaseid}>
                      <TableCell align="center">
                        {bill.purchase_number?.trim() || "-"}
                      </TableCell>
                      <TableCell align="center">
                        {dayjs(bill.purchase_date).isValid()
                          ? dayjs(bill.purchase_date).format("DD-MMM-YYYY")
                          : "-"}
                      </TableCell>
                      <TableCell align="right">
                        {Number(bill.purchase_amount || 0).toFixed(2)}
                      </TableCell>

                      {/* ✅ Dynamic balance logic (matches Receipt live update behavior) */}

                      <TableCell align="right">
                        {(() => {
                          const dbBalance = Number(bill.balance_amount || 0); // ← pending balance from backend
                          const currentAdj = Number(
                            (
                              invoiceAdjustments.find(
                                (a) => a.purchase_id === bill.purchase_id
                              ) || {}
                            ).adjust_amount || 0
                          );
                          const originalAdj = Number(
                            initialPurchaseAdjustMap[bill.purchase_id] || 0
                          );

                          // 🧾 Edit mode → dbBalance already excludes this voucher’s earlier adjustment.
                          // Add it back to show original pending balance before this voucher.
                          const basePending = editData?.id
                            ? dbBalance + originalAdj
                            : dbBalance;

                          // 🧮 Live remaining after user modifies current Adjust Amount
                          const liveRemaining = Math.max(
                            0,
                            basePending - currentAdj
                          );

                          return liveRemaining.toFixed(2);
                        })()}
                      </TableCell>

                      <TableCell align="right">
                        <TextField
                          type="number"
                          size="small"
                          inputProps={{
                            min: 0,
                            step: "0.01",
                            style: { textAlign: "right", width: "100px" },
                          }}
                          value={
                            invoiceAdjustments[idx]?.adjust_amount !== undefined
                              ? Number(
                                  invoiceAdjustments[idx].adjust_amount
                                ).toFixed(2)
                              : "0.00"
                          }
                          onFocus={(e) => {
                            setInvoiceAdjustments((prev) => {
                              const updated = [...prev];

                              const current = Number(
                                updated[idx]?.adjust_amount || 0
                              );
                              const paymentTotal = Number(
                                totalLinesAmount || 0
                              );
                              const adjustedExclCurrent =
                                Number(totalAdjusted || 0) - current;
                              const remaining = Math.max(
                                0,
                                paymentTotal - adjustedExclCurrent
                              );

                              const autoAdjust = Math.min(
                                Number(bill.balance_amount || 0),
                                remaining
                              );

                              // ✅ Auto-fill only if current is 0.00
                              if (current === 0 && autoAdjust > 0) {
                                updated[idx].adjust_amount = Number(
                                  autoAdjust.toFixed(2)
                                );
                              }

                              return updated;
                            });

                            // Highlight text on focus
                            e.target.select();
                          }}
                          onChange={(e) => {
                            let val = e.target.value;
                            if (val === "") val = "0";
                            const numVal = parseFloat(val) || 0;

                            const current = Number(
                              invoiceAdjustments[idx]?.adjust_amount || 0
                            );
                            const paymentTotal = Number(totalLinesAmount || 0);
                            const adjustedExclCurrent =
                              Number(totalAdjusted || 0) - current;
                            const remaining = Math.max(
                              0,
                              paymentTotal - adjustedExclCurrent
                            );
                            const maxAllowed = Math.min(
                              Number(bill.balance_amount || 0),
                              remaining
                            );

                            let finalVal = numVal;
                            if (numVal > maxAllowed) finalVal = maxAllowed;
                            if (numVal < 0) finalVal = 0;

                            setInvoiceAdjustments((prev) => {
                              const updated = [...prev];
                              updated[idx].adjust_amount = finalVal;
                              return updated;
                            });
                          }}
                          onBlur={(e) => {
                            const val = parseFloat(e.target.value) || 0;
                            setInvoiceAdjustments((prev) => {
                              const updated = [...prev];
                              updated[idx].adjust_amount = Number(
                                val.toFixed(2)
                              );
                              return updated;
                            });
                          }}
                          disabled={
                            totalAdjusted >= Number(totalLinesAmount || 0) &&
                            (invoiceAdjustments[idx]?.adjust_amount || 0) === 0
                          }
                        />
                      </TableCell>
                    </TableRow>
                  ))}

                  {/* ✅ Totals Row */}
                  <TableRow
                    sx={{ backgroundColor: "#fafafa", fontWeight: 600 }}
                  >
                    <TableCell colSpan={2} align="right">
                      Totals:
                    </TableCell>
                    <TableCell align="right">
                      {Number(
                        pendingInvoices.reduce(
                          (sum, bill) =>
                            sum + Number(bill.purchase_amount || 0),
                          0
                        )
                      ).toFixed(2)}
                    </TableCell>
                    <TableCell align="right">
                      {Number(
                        pendingInvoices.reduce(
                          (sum, bill, idx) =>
                            sum +
                            (editData?.id
                              ? Number(bill.balance_amount || 0)
                              : Number(bill.balance_amount || 0) -
                                Number(
                                  invoiceAdjustments[idx]?.adjust_amount || 0
                                )),
                          0
                        )
                      ).toFixed(2)}
                    </TableCell>
                    <TableCell align="right">
                      {Number(
                        invoiceAdjustments.reduce(
                          (sum, a) => sum + Number(a.adjust_amount || 0),
                          0
                        )
                      ).toFixed(2)}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          )}

        {/* Save and Cancel Buttons */}
        <Box sx={{ display: "flex", gap: 2 }}>
          <Button
            type="submit"
            variant="contained"
            disabled={loading || !validateVoucher()}
            size="large"
          >
            {editData ? "Update Voucher" : "Create Voucher"}
          </Button>

          <Button
            variant="outlined"
            onClick={onCancel}
            disabled={loading}
            size="large"
          >
            Cancel
          </Button>
        </Box>

        <VoucherPrintPreview
          open={openPrint}
          onClose={() => {
            setOpenPrint(false);
            if (onSuccess) onSuccess(); // ✅ close voucher form after print
          }}
          voucherId={printVoucherId}
        />

 <ConfirmDialog
  open={confirmDialog.open}
  title={confirmDialog.title}
  message={confirmDialog.message}
  onConfirm={confirmDialog.onConfirm}
  onCancel={() => {
    setConfirmDialog({ open: false, title: "", message: "", onConfirm: null });
    onSuccess && onSuccess(); // close form if "No" clicked
  }}
  confirmText="Yes"
  cancelText="No"
  color="primary"
/>


      </form>
    </Paper>
    
  );
}
